import { render, staticRenderFns } from "./ltzjjx4.vue?vue&type=template&id=27f25356&scoped=true&"
import script from "./ltzjjx4.vue?vue&type=script&lang=js&"
export * from "./ltzjjx4.vue?vue&type=script&lang=js&"
import style0 from "./ltzjjx4.vue?vue&type=style&index=0&id=27f25356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f25356",
  null
  
)

export default component.exports